import { render } from "./NoteItem.vue?vue&type=template&id=d2815032&scoped=true"
import script from "./NoteItem.vue?vue&type=script&lang=js"
export * from "./NoteItem.vue?vue&type=script&lang=js"

import "./NoteItem.vue?vue&type=style&index=0&id=d2815032&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2815032"]])

export default __exports__